import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  FormFeedback,
  Form,
  Input,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesRoutes,
  resourcesFuelSales,
  getUnitsWithOperators
} from "../../../helpers/backend_helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";

const formatter = new Intl.NumberFormat('es-MX', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
  price
}) => {
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    route_id: null,
    select: true,
  });
  let params = { params: filters };
  const [routes, setRoutes] = useState([]);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item, unit_price: price },
    validationSchema: Yup.object({
      unit_id: Yup.string().nullable(true).required("Requerido"),
      operator_id: Yup.string().nullable(true),
      date: Yup.date().nullable(true).required("Requerido"),
      time: Yup.string().nullable(true).required("Requerido"),
      amount: Yup.number().nullable(true).min(0.01).required("Requerido"),
      unit_price: Yup.number().nullable(true).required("Requerido"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      await save(values);
    },
  });

  const save = (values) => {
    let method = modal.update ? "put" : "post";
    resourcesFuelSales(method, values, modal.update ? item.id : null).then(
      (response) => {
        setLoading(true);
        responseAction(response);
        setLoading(false);
      }
    );
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.sale;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
    } else {
      setErrors(response.response.data.errors);
    }
  };

  useEffect(() => {
    if (authUser.profile_id == 2) {
      resourcesRoutes("get", {}).then((response) => {
        setRoutes(response.data);
      });
    }
  }, []);

  useEffect(() => {
    getSelectsUnits();
  }, []);

  useEffect(() => {
    validation.setFieldValue('total', formatter.format(validation.values.unit_price * validation.values.amount))
  }, [validation.values.unit_price, validation.values.amount]);

  const getSelectsUnits = () => {
    getUnitsWithOperators(params).then((data) => {
      setUnits(data);
    });
  };

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar" : "Agregar"} Venta de Combustible
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <NibbleInput
                md={6}
                label="Unidad / Camión:"
                fieldName="unit_id"
                fieldType="select"
                selectItems={units}
                selectOptionLabel={e => e.number}
                validation={validation}
              />

              <div className="col-sm-6">
              </div>

              <NibbleInput
                md={6}
                label="Fecha:"
                fieldName="date"
                fieldType="date"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Hora:"
                fieldName="time"
                fieldType="time"
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="Cantidad:"
                fieldName="amount"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="Precio Unitario:"
                fieldName="unit_price"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={4}
                label="Total:"
                fieldName="total"
                fieldType="text"
                validation={validation}
                readOnly={true}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
